const calendar = {
	title: "Kalender",
	new_task: "Ny oppgave",
	new_driving_test: "Ny oppkjøring",
	new_course: "Nytt kurs",
	show_task: "Vis oppgave",
	show_drivingtest: "Vis oppkjøring",
	show_course: "Vis kurs",
	instructor: "Instruktør",
	not_assigned: "Ikke tildelt",
	filter_ctgroup: "Velg kompetanseområde",
};
export default calendar;